import { UserFacingError } from './errors'

export class DogNotFoundError extends UserFacingError {
  constructor() {
    super('Dog not found')
    this.name = 'DogNotFoundError'
  }
}

export class DogRetrieveNotFoundError extends UserFacingError {
  constructor() {
    super('Retrieve log not found')
    this.name = 'DogRetrieveNotFoundError'
  }
}

export class UnauthorizedDogActionError extends UserFacingError {
  constructor() {
    super("You don't have permission for this action")
    this.name = 'UnauthorizedDogActionError'
  }
}

export class DogAlreadyInOrgError extends UserFacingError {
  constructor() {
    super('This dog is already a member of this organization')
    this.name = 'DogAlreadyInOrgError'
  }
}
